import { SxProps } from '@mui/material/styles';
import { columnFlex } from '../../lib/styles/commonStyles';

export const dialogTitleContent: SxProps = {
  marginTop: '24px',
  marginBottom: '8px',
};

export const dialogSnackbarMessage: SxProps = {
  fontWeight: '500',
};

// GeneralLedgerAccountsUpload

export const glAccountsUploadDialog: SxProps = {
  width: '100%',
  maxWidth: '900px', // MUI's 'md'
  '& .MuiDialogTitle-root': {
    padding: '24px 24px 8px 24px',
  },
  '& .MuiDialogContent-root': {
    paddingBottom: '32px',
  },
  '& .MuiDialogActions-root': {
    padding: '0px 24px 24px 24px',
  },
  '& .MuiDialogActions-root>:not(:first-of-type)': {
    marginLeft: 1.5,
  },
};

export const glAccountsUploadDialogDialogCloseButton: SxProps = {
  left: '64px',
};

// GeneralLedgerAccountsCreateEdit

export const createEditOuterBox: SxProps = {
  marginLeft: '24px',
};

export const createEditAlert: SxProps = {
  marginTop: '15px',
  color: 'error',
};

export const createEditDrawerTitle: SxProps = {
  marginTop: '16px',
};

export const createEditCaptionBox: SxProps = {
  marginBottom: '24px',
};

export const createEditDialogElements: SxProps = {
  marginBottom: '8px',
};

// GeneralLedgerAccountsDashboard

export const dashboardHeaderGrid: SxProps = {
  ...columnFlex,
  paddingX: '32px',
  paddingTop: '16px',
};

export const dashboardAddAccountButtonGrid: SxProps = {
  paddingTop: '16px',
  paddingRight: '32px',
};

export const dashboardTabGrid: SxProps = {
  paddingX: '32px',
  paddingTop: '8px',
};

export const dashboardContentGrid: SxProps = {
  paddingX: '32px',
};

// GeneralLedgerAccountsDataGrid

export const dgUpdateIsActiveSuccessSnackbarTypography: SxProps = {
  display: 'inline',
  fontWeight: '500',
};

// GeneralLedgerAccountsDialogContent

export function getDialogContentAccountTitleSx(paddingLeft: number, doSubAccountsExist: boolean): SxProps {
  return {
    paddingLeft: `${paddingLeft}px`,
    marginTop: '16px',
    fontWeight: doSubAccountsExist ? '500' : '400',
  };
}

export function getDialogContentBoxSx(hasEndMessage: boolean): SxProps {
  const sx: SxProps = {
    flexWrap: 'wrap',
    maxHeight: '300px',
    maxWidth: 'sm',
    minWidth: 'sm',
    overflow: 'auto',
  };
  if (hasEndMessage) {
    sx.marginBottom = '16px';
  }

  return sx;
}

// GeneralLedgerAccountsInfo

export const infoDetailsPanelBox: SxProps = {
  marginBottom: '12px',
};

export const infoOuterBox: SxProps = {
  padding: '24px',
};

export const infoAccountDetailsPanelHeader: SxProps = {
  marginBottom: '15px',
};

export const infoSwitch: SxProps = {
  marginBottom: '10px',
};

// GeneralLedgerAccountsManageReport

export function getManageReportOuterBoxSx(shouldHaveRightMargin: boolean): SxProps {
  return shouldHaveRightMargin ? { marginRight: '350px' } : {};
}

export const manageReportFiltersGrid: SxProps = {
  paddingTop: '16px',
  marginBottom: '16px',
};

export const manageReportMultiselectGrid: SxProps = {
  flexGrow: 1,
  width: '214px',
  maxWidth: '275px',
  paddingTop: '16px',
};
